module.exports = {
  ENV: 'prod', //prod
  //API_URL: 'http://gardenpartslen.pl/api/v1',
  //GP_URL: 'http://gardenpartslen.pl',
  //IMG_UPLOAD_URL: 'http://gardenpartslen.pl/commonFileDownload.php',
  // API_URL: 'https://gardenparts.pl/api/v1',
  //API_URL: 'http://test.gardenparts.pl/api/v1'
  //API_URL: 'http://gardenpartslen.pl/api/v1'
}